module.exports = __webpack_public_path__ + "static/media/1.c81da719.png";